import React, { useCallback } from 'react'

import { Button } from 'ui/components/Button'
import {
    Modal,
    ModalCloseTrigger,
    ModalContent,
    ModalFooter,
    ModalFooterButtonGroup,
    ModalHeader,
} from 'ui/components/Modal'
import { GlobalModal, useGlobalModalState } from 'ui/components/Modal/useGlobalModal'

import { useManageDataShareTableModalState } from './hooks/useManageDataShareTableModalState'

type ManageDataShareTableModalData = {
    objectSid: string
}

type ManageDataShareTableModalProps = {}

export const ManageDataShareTableModal: GlobalModal<
    ManageDataShareTableModalData,
    ManageDataShareTableModalProps
> = (props) => {
    const { isOpen, onOpenChange, data } = useGlobalModalState(ManageDataShareTableModal, props)

    const { titleLabel, subtitleLabel, submitLabel, onSubmit } = useManageDataShareTableModalState({
        objectSid: data?.objectSid,
        onOpenChange,
    })

    const onInteractOutside = useCallback((e: Event) => {
        const el = e.target as HTMLElement | null
        if (!el) return

        if (el.closest('.ag-custom-component-popup')) {
            e.preventDefault()
        }
    }, [])

    return (
        <Modal open={isOpen} onOpenChange={onOpenChange} modal={false}>
            <ModalContent
                onInteractOutside={onInteractOutside}
                style={{
                    width: '550px',
                    maxWidth: '90%',
                }}
            >
                <ModalHeader title={titleLabel} subtitle={subtitleLabel} />
                <ModalFooter>
                    <ModalFooterButtonGroup layout="inline">
                        <ModalCloseTrigger asChild>
                            <Button variant="ghost" size="l">
                                Cancel
                            </Button>
                        </ModalCloseTrigger>
                        <Button variant="primary" size="l" onClick={onSubmit}>
                            {submitLabel}
                        </Button>
                    </ModalFooterButtonGroup>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
